import * as React from 'react';

type CardProps = {
  /** The content of the card. */
  children: React.ReactNode;

  /** The title, describing the content of the card. */
  title: string;
};

/**
 * A card is a type of **molecule** that combines multiple HTML elements to display a small container of content.
 */
const Card: React.FC<CardProps> = ({ children, title }) => {
  return (
    <div
      css={{
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 16px 0 rgba(0,116,204,0.08)',
        fontFamily: 'Roboto, sans-serif',
        padding: '24px',
      }}
    >
      <header>
        <h5
          css={{
            color: '#4D555C',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '20px',
            marginBottom: '16px',
            marginTop: 0,
          }}
        >
          {title}
        </h5>
      </header>
      <p
        css={{
          color: '#4B575D',
          fontSize: '48px',
          fontWeight: 700,
          lineHeight: '57px',
          marginBottom: 0,
          marginTop: 0,
        }}
      >
        {children}
      </p>
    </div>
  );
};

export default Card;
